import type { StockCommandMasterEffectV1 } from '@trackeat/shared/sync';

export function recipeFinishedFoodEffect(input: {
  id: string; tenantId: string; name: string; uom: string;
  allergens: string[]; recipeId: string;
}): StockCommandMasterEffectV1 {
  return {
    table: 'foods', id: input.id, op: 'insert', base_version: 0,
    patch: {
      id: input.id, tenant_id: input.tenantId, creation_source: 'quick_label',
      name: input.name,
      description: 'Prodotto finito — generato automaticamente dalle etichette',
      category: 'altro', default_uom: input.uom, storage_type: 'fresco',
      allergens: input.allergens, recipe_id: input.recipeId,
    },
  };
}
